function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "wq7l9mv85a",
  x1: "16.886%",
  x2: "78.894%",
  y1: "12.353%",
  y2: "108.129%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#56FDD2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.96%",
  stopColor: "#363B7F"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.228
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#wq7l9mv85a)",
  transform: "translate(0 -295)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-67.076 890.268c112.5 207.258 393.04 34.554 357.077-290.533-35.964-325.087-285.906-309.767-394.672-282.01-108.766 27.757-252.744 121.664-252.765 282.095-.021 160.431 177.862 83.19 290.36 290.448z",
  transform: "rotate(-16 -32.138 642.355)"
})));

var SvgIconOvalLeft2 = function SvgIconOvalLeft2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 651,
    viewBox: "0 0 302 651",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOvalLeft2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-oval-left-2.6be173a4.svg";
export { ForwardRef as ReactComponent };